'use strict';

function BankError() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];
  this._history = new History();

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[BankError]';

  this.init = function () {
    if (this._DEBUG) console.log(this.pageName + ' init() called');

    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this.analytics.pushEvent('virtual-page-view');

    // Update Configs to by pass creating the general PlaidBankError
    // Create Unexpected_error view instead
    this.updateErrorConfigs({
      initErrorPage: false
    });

    // Redirect users to FS if bvStatus is one of the following
    var bvStatus = this._getBankVerificationStatus();
    if (bvStatus) {
      bvStatus = bvStatus.status;
      if (bvStatus === 'submitted' || bvStatus === 'failed' || bvStatus === 'verified') {
        if (this._DEBUG) {
          console.log(this.pageName + ' - user has already attempted ABV - ABV status of submitted || failed || verified, redirecting ... ');
        }
        // do not allow user to verify bank here if they have already attempted to do so
        window.location.replace('/portal/dashboard?arn=true');
        return;
      }
    }

    // Create DLT error page for Mini Flow
    var customErrorPage = this.node.getElementsByClassName('js--custom-error-page')[0];
    customErrorPage.mogo().create('PlaidBankError', {
      errorType: customErrorPage.classList.contains('js--dlt-fallback-error-page') ? 'DLT_FALLBACK_ERROR' : 'UNEXPECTED_ERROR',
      callback: this._setupEventHandlers.bind(this)
    });

    this._setupLivechat();
  };

  this._setupEventHandlers = function (_ref) {
    var _this = this;

    var errorType = _ref.errorType;

    $('.js--plaid-bank-error-btn--secondary').on('click', function () {
      _this._history.goToUrl('/member/dashboard/home');
    });
    $('.js--plaid-bank-error-btn--primary').on('click', function () {
      if (errorType === 'DLT_FALLBACK_ERROR') {
        _this._generateDLTCode();
      } else {
        _this._history.goToUrl('/member/dashboard/loans/apply/bank-statement/verify');
      }
    });
  };

  // This is only called in Mini Flow
  this._generateDLTCode = function (id, callbacks) {
    var _this2 = this;

    if (this._DEBUG) console.log(this.pageName + ' _generateDLTCode() called');

    if (this.presenter.hasAction('banking.accounts.generate_dlt_code')) {
      this.presenter.performAction('banking.accounts.generate_dlt_code', null, function (data, response) {
        if (_this2.isGeneralConnectionIssue(data, response)) {
          if (!_this2._errorInitialized) {
            _this2._errorInitialized = true;
            _this2.invokeConnectionIssuePage({ action: 'banking.accounts.generate_dlt_code' }, { productLabel: 'MogoMoney' }, null, _this2._connectionIssueConfig);
          }
        } else if (response === 200) {
          if (_this2._DEBUG) {
            console.log(_this2.pageName + ' rel link - banking.accounts.generate_dlt_code Success');
          }
          var dltCode = data.dlt_code;
          if (dltCode) {
            _this2._updateFSBankAccountModel(dltCode);
          } else {
            console.warn('Missing dlt_code key in data object.');
          }
        } else {
          console.warn('Error calling rel link - banking.accounts.generate_dlt_code: ' + data + ', ' + response);
          failureCallback(data, response);
        }
      });
    } else {
      console.warn('Missing rel-link: banking.accounts.generate_dlt_code');
    }
  };

  /*
   This is the model that the Verify Page reads from
   On reload of Verify page, dlt_code property gets added to the FS Bank account model via backend
  */
  this._updateFSBankAccountModel = function (dltCode) {
    var FSBankAccount = this.presenter.getModelProperty('money.loans.fs_loans.bank_account');

    if (!FSBankAccount) {
      console.warn('No FS bank Account object -  money.loans.fs_loans.bank_account');
    } else {
      this.presenter.setModelProperty('money.loans.fs_loans.bank_account.dlt_code', dltCode);
      this._openDLTLinkAndRedirect(dltCode);
    }
  };

  // Open DLT Link in new tab
  // Re-direct user to the Verify Bank Statement Page.
  // That page should have updated state to reflect the newly generated DLT code at this point
  // because model is been updated by this._updateFSBankAccount() function above
  this._openDLTLinkAndRedirect = function (dltCode) {
    if (this._DEBUG) console.log(this.pageName + ' _openDLTLinkAndRedirect() called');

    // DLT here
    var dltPage = 'https://www.decisionlogic.com/' + dltCode;
    window.open(dltPage, '_blank');

    // Redirect to verify page
    this._history.goToUrl('/member/dashboard/loans/apply/bank-statement/verify');
  };

  // Function copied from else where;
  this._setupLivechat = function () {
    // scope variables because elements might not be visible yet
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");
    this._$liveChat = $('.js--live-chat');

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$liveChat.length > 0 && this._liveChatComponent.length === 0) {
      this._$liveChat.mogo().create('LiveChat', {
        presenter: this.presenter
      });
    } else if (this._liveChatComponent.length) {
      this._liveChatComponent.mogo().minimizeChatOnPage();
      this._liveChat = this._liveChatComponent;
    }
  };

  this.destroy = function () {};
}